import { Badge } from "@/components/ui/badge";
import { Eye } from "lucide-react";
import { totalCredits } from "./adminHelpers";

const AdminUsersTable = ({ users, orders, onOpenUser, onAddCredits }) => (
  <div className="rounded-3xl bg-[#18181B] border border-white/10 overflow-x-auto">
    <table className="w-full text-sm">
      <thead className="text-zinc-500 uppercase text-xs border-b border-white/10">
        <tr><th className="text-left p-4">Nom</th><th className="text-left p-4">Email</th><th className="text-left p-4">Club</th><th className="text-left p-4">Crédits</th><th className="text-left p-4">Commandes</th><th className="text-left p-4">Rôle</th><th className="text-right p-4">Actions</th></tr>
      </thead>
      <tbody>
        {users.map((user) => {
          const userOrders = orders.filter((order) => order.user_email === user.email || order.user_id === user.id);
          return (
            <tr key={user.id} className="border-b border-white/5 hover:bg-white/[0.02]">
              <td className="p-4 text-white font-semibold">{user.first_name} {user.last_name}</td>
              <td className="p-4 text-zinc-400">{user.email}</td>
              <td className="p-4 text-zinc-400">{user.club || "-"}</td>
              <td className="p-4 text-[#CCFF00] font-bold">{totalCredits(user)}</td>
              <td className="p-4 text-white">{userOrders.length}</td>
              <td className="p-4"><Badge className={user.role === "admin" ? "bg-red-500/20 text-red-400" : "bg-zinc-500/20 text-zinc-400"}>{user.role || "user"}</Badge></td>
              <td className="p-4"><div className="flex justify-end gap-2"><button onClick={() => onOpenUser(user)} className="border border-white/20 text-white px-3 py-1.5 text-xs font-bold uppercase hover:bg-white/5"><Eye className="w-3 h-3 inline mr-1" />Voir</button><button onClick={() => onAddCredits(user.id)} className="bg-[#CCFF00] text-black px-3 py-1.5 text-xs font-bold uppercase hover:bg-[#AACC00]">+ Crédit</button></div></td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);

export default AdminUsersTable;
